import { gql } from '@apollo/client'
import { BDME_CODE, DEAL_STATUS } from '../cache/latest-deal-info'

export interface IDeal {
  bdId: number
  dealNumber: number
  dealVersionNumber: number
  versionStatus: DEAL_STATUS
  bdmeCode: BDME_CODE
  dealLockFlag: string
  dealLockUser: string
  currentVersionFlag: string
  isDealExpired: boolean
  dealType: string
  freezeFlag: string
  tenantId?: string
  businessModelCode?: string
  controlCountryCode?: string
}

export interface IDealSearchResponse {
  searchDeal: {
    didError: boolean
    errorCode?: string
    errorMessage?: string
    infoMessage?: string
    deals: IDeal[]
  }
}

export interface IDealSearchOptions {
  dealFilter: string
  searchBy: string
  tenant: string
  searchByEffectiveDate: boolean | Date
  searchByExpirationDate: boolean | Date
  searchByFirstQuoteDate: boolean | Date
  searchByRevisionDate: boolean | Date
  searchByOption: string
  searchText: string
}

export interface IDealSearchRequest {
  dealSearchRequest: IDealSearchOptions
}

const SEARCH_DEAL = gql`
  query SearchDeal($dealSearchRequest: DealSearchRequestInput!) {
    searchDeal(dealSearchRequest: $dealSearchRequest) {
      didError
      errorCode
      errorMessage
      infoMessage
      deals {
        bdId
        dealNumber
        dealVersionNumber
        versionStatus
        dealLockFlag
        bdmeCode
        dealLockUser
        currentVersionFlag
        isDealExpired
        dealType
        freezeFlag
        tenantId
        businessModelCode
        controlCountryCode
      }
    }
  }
`

export default SEARCH_DEAL
